import { gql } from 'apollo-angular';

const ADD_ORGANIZATIONS_INTO_HIERARCHY = gql`
  mutation AdminAddOrganizationMember(
    $addMembersRequest: AddRemoveGroupMembersRequest!
  ) {
    addMembers(addMembersRequest: $addMembersRequest) {
      id
      organizationHirerachy {
        children {
          id
          name
        }
      }
    }
  }
`;

export default ADD_ORGANIZATIONS_INTO_HIERARCHY;
